<template>
  <div>
    <t-form labelWidth="90px">
      <t-form-item>
        <template #label>
          <t-popup placement="bottom" show-arrow destroy-on-close>
            <template #content>
              <div style="width: 300px">
                天气API有免费调用额度，独立部署时请自行更换API-KEY，详见
                <a style="color: #4fa1ff" href="https://colaiven.gitee.io/cola-designer-pro-doc/start/component.html#%E5%A4%A9%E6%B0%94" target="_blank">使用说明</a>
              </div>
            </template>
            <span>api-key </span> <t-icon name="help-circle-filled"/>
          </t-popup>
        </template>
        <t-input v-model="attribute.apiKey" size="small"/>
      </t-form-item>
      <t-form-item label="省份">
        <t-select v-model="provinceCode" size="small" @change="changeProvince">
          <t-option label="全国" value="china"/>
          <t-option v-for="(item,index) in cityProvince" :key="index" :label="item.name" :value="item.code"/>
        </t-select>
      </t-form-item>
      <t-form-item label="城市">
        <t-select v-model="cityCode" size="small" clearable @change="confirmCity">
          <t-option v-for="(item,index) in cities" :key="index" :label="item.name" :value="item.name"/>
        </t-select>
      </t-form-item>
      <t-form-item>
        <t-button block @click="attribute.refreshFlag=!attribute.refreshFlag">刷新</t-button>
      </t-form-item>
    </t-form>
  </div>
</template>

<script>
import cityProvince from "@/assets/map/city-province.json";
import {getChildByParentCode} from "@/utils/map-manage";

export default {
  name: "cpt-weather-option",
  props: {attribute: Object},
  data() {
    return {
      cityProvince,
      cities:[],
      provinceCode:'',
      cityCode:''
    }
  },
  methods:{
    changeProvince(val){
      this.cityCode = ''
      if(val === 'china'){
        this.cities = [];
      }else{
        this.cities = getChildByParentCode(val)
      }
    },
    confirmCity(val){
      this.attribute.cityName = val
    }
  }
}
</script>

<style scoped>

</style>